<template>
  <div class="archive">
    <!-- Thumbnails -->
    <div class="thumbnail-container">
      <img v-lazy-load :width="image.Sizes[0]" :height="image.Sizes[1]" :data-src="image.Resized[0]" :src="require('@/assets/images/placeholder.png')" v-for="(image, index) in images" :key="index" :class="{'thumbnail-active': index === active}" class="thumbnail" @mouseover="active = index" @click="showImage(index)"/>
    </div>
  </div>
</template>

<script>
import { lazyLoadDirective } from '@/directives/lazyLoad'

export default {
  directives: {
    'lazy-load': lazyLoadDirective
  },
  props: {
    images: Array
  },
  data () {
    return {
      active: false,
      currentIndex: 0
    }
  },
  mounted () {
  },
  methods: {
    showImage (index) {
      if (index !== false && index < this.images.length) {
        this.currentIndex = index
        const i = this.images[index]
        const dataset = {
          large: i.Resized[2],
          srcset: i.Resized,
          caption: this.$root.md(i.Captions[0]),
          width: i.Sizes[0],
          height: i.Sizes[1],
          showNext: () => { this.showImage(index + 1) }
        }
        this.$root.$emit('overlay-opened', dataset)
      } else {
        this.$root.$emit('overlay-close')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../main';
.archive {
  .thumbnail-container {
    display: flex;
    flex-wrap: wrap;
    img {
        width: 20%;
        height: auto;
        background: #CCC;
        aspect-ratio: 1;
        object-fit: cover;
        @include tb() {
            width: 33.333%;
        }
        @include sm() {
            width: 50%;
        }
        border: 2px solid var(--extra-dimmed-background);
        box-sizing: border-box;
        filter: grayscale(100%);
        opacity: 0.5;
        &.thumbnail-active {
            opacity: 1;
            filter: grayscale(0%);
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GalleryArchive.vue